import React from 'react';
import { translate, Interpolate } from 'react-i18next';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { sunburst } from 'react-syntax-highlighter/styles/hljs';
import Collapsible from 'react-collapsible';
import businessDataKeys from './../../data/businessDataKeys';
import ApiDefinitionRow from '../ApiDefinitionRow';
import LegalForms from '../LegalForms';

const exampleObject = `{
  "mise_id": "123",
  "registration_number": "123456-7890",
  "business_name": "DUMMY EXAMPLE COMPANY",
  "street_address": "DUMMY ADDRESS",
  "co_address": "DUMMY C/Oaddress",
  "postal_code": "44433",
  "post_town": "DUMMY POSTAL TOWN",
  "visit_address": "DUMMY VISIT ADDRESS",
  "visit_address_postal_code": "44433",
  "visit_address_post_town": "DUMMY VISIT POSTAL TOWN",
  "email": "test@test.se",
  "webpage": "www.test.se",
  "phone": "+46 8-213212",
  "industry_code_1": "55555",
  "industry_code_1_text": "Code 1 Text",
  "legal_form_code": "44",
  "legal_form_text": "Dummy foundation",
  "status": "J",
  "registration_date": "2016-09-13",
  "number_of_work_places": "2",
  "number_of_employees_code": "09",
  "number_of_employees_text": "500-999 Employees",
  "sales_code": "10",
  "sales_text": "1 000 000 - 4 999 999 tkr",
  "key_performance_indicator": {
    "number_of_employees": 22,
    "employee_turnover": 1,
    "turnover": 67,
    "equity_ratio": 33.5
  },
  "decisionmakers_list": [
    {
      "title": "CEO",
      "first_name": "John",
      "last_name": "Smith",
      "email": "john.smith@test.se",
      "direct_no": "+46 8-3212321"
    },
    {
      "title": "Marketing director",
      "first_name": "James",
      "last_name": "Johnson",
      "email": "james.johnson@test.se",
      "direct_no": "+46 8-552321"
    },
    {
      "title": "CFO",
      "first_name": "David",
      "last_name": "Miller",
      "email": "David.miller@test.se",
      "direct_no": "+46 8-552323"
    },
    {
      "title": "IT director",
      "first_name": "Michael",
      "last_name": "Williams",
      "email": "michael.williams@test.se",
      "direct_no": "+46 8-566323"
    }
  ],
  "work_places": [
    {
      "mise_id": 233,
      "cfar_no": 12345678,
      "co_address": "DUMMY C/Oaddress",
      "address": "DUMMY WORKPLACE1 ADDRESS",
      "postal_code": "55522",
      "post_town": "DUMMY WORKPLACE1 POSTAL TOWN",
      "visit_address": "DUMMY WORKPLACE1 VISIT ADDRESS",
      "visit_postal_code": "55522",
      "visit_post_town": "DUMMY WORKPLACE1 VISIT POSTAL TOWN",
      "designation": "DUMMY WORKPLACE1 LABEL",
      "industry_code": "55555",
      "industry_code_text": "Code text",
      "phone_no": "+46 652-22112",
      "registration_date": "2016-09-13",
      "number_of_employees_code": "09",
      "number_of_employees_text": "500-999 Employees",
      "type_of_work_place": "HQ",	
    },
    {
      "mise_id": 2331,
      "cfar_no": 34567890,
      "co_address": "DUMMY C/Oaddress",
      "address": "DUMMY WORKPLACE2 ADDRESS",
      "postal_code": "66622",
      "post_town": "DUMMY WORKPLACE2 POSTAL TOWN",
      "visit_address": "DUMMY WORKPLACE2 VISIT ADDRESS",
      "visit_postal_code": "55522",
      "visit_post_town": "DUMMY WORKPLACE2 VISIT POSTAL TOWN",
      "designation": "DUMMY WORKPLACE2 LABEL",
      "industry_code_1": "55555",
      "industry_code_1_text": "Code 1 Text",
      "phone_no": "+46 652-12112",
      "registration_date": "2016-09-13",
      "number_of_employees_code": "09",
      "number_of_employees_text": "500-999 Employees",
      "type_of_work_place": "F",
    }
  ]
}`;

const BusinessDataSection = (props) => (
  <section className="method row" id="business-data">
  <div className="method__text method__text col-lg-6">
    <h1 className="h2">{props.t('title')}</h1>
    <hr />
    <Interpolate i18nKey='description' useDangerouslySetInnerHTML={true} />

      <ul className="api-definition-list">
        { businessDataKeys.map((item, index) => <ApiDefinitionRow item={item} key={index} namespaces={['BusinessDataSection']} /> )}
      </ul>

    <div className="definitions pt-3 pb-3">

      <LegalForms />
    
      {/*
      <Collapsible trigger="Översättningstabell Storleksklass anställda" classParentString="card" triggerClassName="card-header" triggerOpenedClassName="card-header">
        <div className="table-responsive">
          <table className="table table-striped table-sm">
            <thead>
              <tr>
                <th>Kod</th>
                <th>Text</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>00</th>
                <td>Uppgift saknas</td>
              </tr>
              <tr>
                <th>01</th>
                <td>0 anställda</td>
              </tr>
              <tr>
                <th>02</th>
                <td>1 - 4 anställda</td>
              </tr>
              <tr>
                <th>03</th>
                <td>5 - 9 anställda</td>
              </tr>
              <tr>
                <th>04</th>
                <td>10 - 19 anställda</td>
              </tr>
              <tr>
                <th>05</th>
                <td>20 - 49 anställda</td>
              </tr>
              <tr>
                <th>06</th>
                <td>50 - 99 anställda</td>
              </tr>
              <tr>
                <th>07</th>
                <td>100 - 199 anställda</td>
              </tr>
              <tr>
                <th>08</th>
                <td>200 - 499 anställda</td>
              </tr>
              <tr>
                <th>09</th>
                <td>500 - 999 anställda</td>
              </tr>
              <tr>
                <th>10</th>
                <td>1 000 - 1 499 anställda</td>
              </tr>
              <tr>
                <th>11</th>
                <td>1 500 - 1 999 anställda</td>
              </tr>
              <tr>
                <th>12</th>
                <td>2 000 - 2 999 anställda</td>
              </tr>
              <tr>
                <th>13</th>
                <td>3 000 - 3 999 anställda</td>
              </tr>
              <tr>
                <th>14</th>
                <td>4 000 - 4 999 anställda</td>
              </tr>
              <tr>
                <th>15</th>
                <td>5 000 - 9 999 anställda</td>
              </tr>
              <tr>
                <th>16</th>
                <td>10 000 anställda eller fler</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Collapsible>

      <Collapsible trigger="Översättningstabell Storleksklass omsättning kod" classParentString="card" triggerClassName="card-header" triggerOpenedClassName="card-header">
        <div className="table-responsive">
          <table className="table table-striped table-sm">
            <thead>
              <tr>
                <th>Kod</th>
                <th>Omsättning</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>00</th>
                <td>&lt; 1 tkr</td>
              </tr>
              <tr>
                <th>01</th>
                <td>1 - 499 tkr</td>
              </tr>
              <tr>
                <th>02</th>
                <td>500 - 999 tkr</td>
              </tr>
              <tr>
                <th>03</th>
                <td>1 000 - 4 999 tkr</td>
              </tr>
              <tr>
                <th>04</th>
                <td>5 000 - 9 999 tkr</td>
              </tr>
              <tr>
                <th>05</th>
                <td>10 000 - 19 999 tkr</td>
              </tr>
              <tr>
                <th>06</th>
                <td>20 000 - 49 999 tkr</td>
              </tr>
              <tr>
                <th>07</th>
                <td>50 000 - 99 999 tkr</td>
              </tr>
              <tr>
                <th>08</th>
                <td>100 000 - 499 999 tkr</td>
              </tr>
              <tr>
                <th>09</th>
                <td>500 000 - 999 999 tkr</td>
              </tr>
              <tr>
                <th>10</th>
                <td>1 000 000 - 4 999 999 tkr</td>
              </tr>
              <tr>
                <th>11</th>
                <td>5 000 000 - 9 999 999 tkr</td>
              </tr>
              <tr>
                <th>12</th>
                <td>2 000 - 2 999 anställda</td>
              </tr>
              <tr>
                <th>13</th>
                <td>&gt; 9 999 999 tkr</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Collapsible> */}
    </div>



  </div>
  <div className="method__code col-lg-6">
    <small>{props.t('example.businessDataEndpoint')}</small>
    <SyntaxHighlighter language='text' style={sunburst}>
      {
        `https://mise.se/TestAPI/api/`
      }          
    </SyntaxHighlighter>
    <small>{props.t('example.businessObject')}</small>
    <SyntaxHighlighter language='json' style={sunburst}>
      { exampleObject }          
    </SyntaxHighlighter>
  </div>
</section>

);

export default translate('BusinessDataSection')(BusinessDataSection);



// WEBPACK FOOTER //
// ./src/components/sections/BusinessDataSection.jsx